// extracted by mini-css-extract-plugin
export default {"container":"IO-z","dimension":"JO-z","dimensionLabels":"KO-z"};